/** Consentement à la collecte de données personnelles (employé / candidat). */

export type ConsentSubjectType = 'employee' | 'candidate';
export type ConsentMethod = 'formulaire_erp' | 'papier_scanné' | 'email' | 'verbal_retranscrit';

export const CONSENT_METHODS: { value: ConsentMethod; label: string }[] = [
  { value: 'formulaire_erp', label: 'Formulaire ERP' },
  { value: 'papier_scanné', label: 'Papier scanné' },
  { value: 'email', label: 'Email' },
  { value: 'verbal_retranscrit', label: 'Verbal retranscrit' },
];

export interface DataConsent {
  id: string;
  subject_type: ConsentSubjectType;
  subject_id: string;
  policy_version: string;
  consent_given: boolean;
  consent_date: string;
  consent_method: ConsentMethod;
  collected_by: string;
  notes?: string;
  withdrawn_at?: string;
  withdrawn_by?: string;
}

export function latestConsentForSubject(
  consents: readonly DataConsent[],
  subjectType: ConsentSubjectType,
  subjectId: string,
): DataConsent | null {
  const rows = consents
    .filter((c) => c.subject_type === subjectType && c.subject_id === subjectId)
    .sort((a, b) => b.consent_date.localeCompare(a.consent_date));
  return rows[0] ?? null;
}

export function isConsentWithdrawn(consent: DataConsent | null): boolean {
  return Boolean(consent?.withdrawn_at);
}
